export default __webpack_public_path__ + "static/media/footer-logo-immunespace-whiteblue.f13b974e.png";